import { TenantModel } from '../domain';

export abstract class TenantRepository {
  abstract getTenants(): Promise<TenantModel[]>;

  abstract getTenantById(tenantId: number): Promise<TenantModel>;
}
